module.exports = __webpack_public_path__ + "img/Picture6.f0d1bcfd.jpg";